import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import Button from "@Front/Components/DesignSystem/Button";
import classes from "../classes.module.scss";

type StepSsoProfessionalSectionProps = {
	title: string;
	cta: string;
	onClick: () => void | Promise<void>;
};

export default function StepSsoProfessionalSection({ title, cta, onClick }: StepSsoProfessionalSectionProps): React.JSX.Element {
	return (
		<div className={classes["section"]}>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT} className={classes["section-title"]}>
				{title}
			</Typography>
			<Button className={classes["sso-pro-directory-cta"]} onClick={onClick}>
				{cta}
			</Button>
		</div>
	);
}
